import { LocaleContext } from "core/context/LocaleContext";
import { useContext } from "react";

export function useLocale() {
  return useContext(LocaleContext);
}
